type ISiteButtonAlign = 'left' | 'right';

interface ISiteCardMenuItem
    extends ISiteActionButton {
    
    align?: ISiteButtonAlign;
    items?: ISiteCardMenuItem[];
}

class SiteCardMenu
    extends QueryElement<HTMLElement> {

    constructor(card: SiteCard, items: ISiteCardMenuItem[]) {
        super(document.createElement("UL"));
        
        this.addClass("menu");

        this.append(new SiteCardMenuItem(card, {
            icon: "arrow_back",
            action: {
                type: "Close"
            }
        }).addClass("show-mobile"));

        for(let item of items) {
            this.append(new SiteCardMenuItem(card, item));
        }
    }
}

class SiteCardMenuItem
    extends QueryElement<HTMLElement> {

    constructor(card: SiteCard, button: ISiteCardMenuItem) {
        super(document.createElement("LI"));

        if (!!button.action || button.items) {
            // Putting the index to the end of the queue
            let actionButton = new SiteActionButton(card, button);
            actionButton.setAttr("data-tab-index", "30000");

            this.append(actionButton);

            // Add subitems
            if (button.items) {
                this.append(new SiteCardMenu(card, button.items));
                this.addClass("items");
            }
        }
    }
}